function getIdHistorico(num, tope) {
  const tipoHistorico = tope === '1' ? 'BO' : 'AV';
  return `${tipoHistorico}_${num.padStart(4, '0')}`;
}

export default getIdHistorico;
